/**
 * setup code for pyatt app
 */

;(function (pyatt, $, window, document, undefined) {

    // Document ready
    $(function () {
        
        // Init sliders
        pyatt.featuredSlider.init();
        pyatt.processSlider.init();
        pyatt.portfolioGallery.init();

        // Init grid filtering
        pyatt.portfolioGrid.init();

        // Init contact form helpers
        pyatt.contactForm.init();

        pyatt.resizeVideo.init();
        pyatt.blogFilter.init();

        // $(window).on('resize', Foundation.utils.throttle(function() {
        //     pyatt.modifyPostListLinks();
        // }, 300));

    });

    

}(window.pyatt = window.pyatt || {}, jQuery, window, window.document));